export default __webpack_public_path__ + "static/media/minicaps.93d4b6cb.ttf";